// @flow
import * as React from 'react';
import moment from 'moment';
import SingleDatePicker from 'common/components/ui/datePicker/SingleDatePicker';
import FullISOWeekPicker from 'common/components/ui/datePicker/FullISOWeekPicker';
import WeekPicker from 'common/components/ui/datePicker/WeekPicker';
import WeekEndPicker from 'common/components/ui/datePicker/WeekEndPicker';
import DateRange from 'common/domain/DateRange';
import type { DateRangePeriod } from '../../../domain/MetricsPeriods';

interface Props {
  dateRange: DateRange;
  minDate?: moment;
  maxDate?: moment;
  period: DateRangePeriod;
  onChange: (DateRange) => void;
}

export default function MetricsDateRangePicker(props: Props) {
  const { period } = props;
  function onSingleDayChange(date: moment) {
    props.onChange(new DateRange({
      from: date,
      to: date,
    }));
  }

  if (period === 'FULL_WEEK') {
    return <FullISOWeekPicker {...props} />;
  }

  if (period === 'WEEK_DAYS') {
    return <WeekPicker {...props} />;
  }

  if (period === 'WEEKEND') {
    return <WeekEndPicker {...props} />;
  }

  return (
    <SingleDatePicker
      date={props.dateRange.from}
      minDate={props.minDate}
      maxDate={props.maxDate}
      onChange={onSingleDayChange}
    />
  );
}



// WEBPACK FOOTER //
// ./src/statsradio/modules/metrics/v2/components/parameters/MetricsDateRangePicker.js